import React from 'react'
import { NumberInput } from 'react-admin'
import { MainProductAPIEntity } from 'services/api/entities'
import { useKResource } from 'services/hooks/useKResource'
import CatalogOptionsInput from 'ui-shared/FormComponents/CatalogOptionsInput'
import StandardPricingInput from 'ui-shared/FormComponents/pricing/standard/StandardPricingInput'
import UpsellingSelector, {
  UpsellingSelectorProps,
} from 'ui-shared/FormComponents/UpsellingSelector'
import BookingTimeLimitInput from 'ui-shared/WrappedInputs/BookingTimeLimitInput'
import HighlightsInput from 'ui-shared/WrappedInputs/HighlightsInput'
import MainProductForm, { MainProductFormProps } from './MainProductForm'

export type OptionedProductFormProps = MainProductFormProps &
  UpsellingSelectorProps & {
    slotBeforeHighlights?: React.ReactElement
  }

const OptionedProductForm: React.FC<OptionedProductFormProps> = ({
  upsellingEntity,
  children,
  slotBeforeHighlights,
  ...props
}) => {
  const resource = useKResource<MainProductAPIEntity>()
  return (
    <MainProductForm {...props}>
      <UpsellingSelector upsellingEntity={upsellingEntity} />
      <NumberInput source="minQuantity" label="Min Quantity" fullWidth />
      <BookingTimeLimitInput resource={resource} />
      {slotBeforeHighlights}
      <HighlightsInput />
      <CatalogOptionsInput />
      <StandardPricingInput />
      {children}
    </MainProductForm>
  )
}

export default OptionedProductForm
